export default "__VITE_ASSET__CDUW5lrs__"